import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

// TODO: Refactor this to use flex or grid layout instead of calc.
// See https://www.notion.so/wandbai/height-calc-100vh-60px-is-cursed-345e2f5c7ef3804795cfd6e62fb2f041
// oxlint-disable-next-line wandb/no-calc-100vh-pixel-math
export const Container = styled.div<{selected: boolean; loaded: boolean}>`
  width: min(calc(100vw - 64px), 550px);
  margin: 0 auto;
  border-radius: 15px;
  visibility: ${props => (props.loaded ? 'visible' : 'hidden')};

  ${props =>
    props.selected &&
    css`
      box-shadow: 0 0 0 6px light-dark(rgb(208, 225, 252), var(--blue-700));
    `}
`;
